import { lazy } from "react";

const WalletPage = lazy(() => import("../../../pages/User/wallet/Wallet"));
const UpdateWalletAccount = lazy(() => import("../../../pages/User/wallet/UpdateWalletAccountDetails"));

export const walletRoutes = [
  { path: "wallet", element: <WalletPage/> },
  { path: "wallet/update-account", element: <UpdateWalletAccount/> },
];
